<template>
  <el-table-column
    prop="customer.name"
    sortable="custom"
    label="Atvevő"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <span>{{ scope.row.customer_name }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'customer.name',
  };
</script>
